<div class="container d-flex flex-column align-items-center justify-content-center">
  @if (!isDam) {
    <div class="text-center p-4" style="max-width: 400px">
    <i class="{{ aprobedpayment ? 'iconaprob' : 'iconaprobRec' }} lni {{
        aprobedpayment ? 'lni-checkmark-circle' : 'lni-cross-circle'
      }}"></i>
      <h3 class="m-3 boldtext">{{ titlepayment }}</h3>
      @if (channel !== 6) {
        <p>
          Tu satisfacción nos impulsa a mejorar nuestros servicios. Te deseamos
          éxitos en el alcance y logro de tus metas. Recuerda que estamos para
          servirte.
        </p>
      }
    </div>
  }
  @if (this.rejectReason != '') {
    <label class="mt-3 text-start w-100" style="max-width: 400px">Motivo de
    rechazo</label>
  }
  @if (this.rejectReason != '') {
    <div class="row w-100" style="max-width: 400px;">
      <p>
        {{this.rejectReason}}
      </p>
    </div>
  }
  <label class="mt-3 text-start w-100" style="max-width: 400px">Detalle del Proceso</label>
  <div class="row w-100 transationdiv" style="max-width: 400px">
    <div style="display: flex;" class="col text-start">Estado:</div>
    <div class="col-6 text-end {{aprobedpayment ? 'aprobtext' : 'declinedtext'}} boldtext">
      {{ estatuspayment }}
    </div>
  </div>
  <div class="row w-100 transationdiv" style="max-width: 400px">
    <div style="display: flex;" class="col text-start">Monto pagado:</div>
    <div class="col-6 text-end">{{ currency }} {{ paidAmount }}</div>
  </div>
  <div class="row w-100 transationdiv" style="max-width: 400px">
    <div style="display: flex;" class="col text-start">Monto reversado:</div>
    <div class="col-6 text-end">{{ currency }}{{ reversedAmount }}</div>
  </div>
  <div class="row w-100 transationdiv" style="max-width: 400px">
    <div style="display: flex;" class="col text-start">Fecha y hora:</div>
    <div class="col-6 text-end">{{ datepayment }}</div>
  </div>
  @if (!isDam) {
    <div class="row w-100 text-center align-items-center justify-content-center" style="max-width: 400px">
      @if (aprobedpayment) {
        <p class="mt-3 boldtext">
          Recibirás un correo electrónico de confirmación de guardado de tu tarjeta.
        </p>
      }
      @if (isNationalCard) {
        <p class="mt-3 boldtext text-danger">
          Tu débito automático mensual no se puede afiliar, ya que solo se permiten tarjetas emitidas en Salvador para este
          proceso.
        </p>
      }
      @if (isErrorDomiciliation) {
        <p class="mt-3 boldtext text-danger">
          Error en el proceso de Domiciliación: {{MessageDomiciliation}}.
        </p>
      }
    </div>
  }
</div>